import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material'
import { ScheduleTypeEnum } from '@ulysses-inc/harami_api_client'
import type React from 'react'
import FormikErrorMessage from 'src/components/formikErrorMessage/FormikErrorMessage'
import type { TBaseFormRowProps } from './EditSchedule'

const ScheduleTypeRow: React.FC<TBaseFormRowProps> = ({
  setFieldValue,
  values: { type },
  errors,
}) => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue('frequency', undefined)
    setFieldValue('frequencyWeekly', undefined)
    setFieldValue('frequencyMonthly', undefined)
    setFieldValue('frequencyCustom', undefined)
    setFieldValue('startReportDate', undefined)
    setFieldValue('endReportDate', undefined)
    setFieldValue('type', Number(e.target.value))
  }

  return (
    <Stack>
      <Typography variant="subtitle1" fontWeight="bold">
        タイプ
      </Typography>
      <Stack direction="row">
        <RadioGroup
          name="radiogroup"
          onChange={onChange}
          value={type ?? ''}
          row
        >
          <FormControlLabel
            value={ScheduleTypeEnum.Date}
            control={<Radio />}
            label="日にち"
          />
          <FormControlLabel
            value={ScheduleTypeEnum.Duration}
            control={<Radio />}
            label="期間"
          />
        </RadioGroup>
      </Stack>
      <Stack>
        <FormikErrorMessage name="type" errors={errors} />
      </Stack>
    </Stack>
  )
}

export default ScheduleTypeRow
